module.exports = __webpack_public_path__ + "img/delete-transfer.763a8b5f.svg";